<template>
    <div class="loginFailure">
            errrrrrrr
    </div>
</template>
<script >
export default {
    name: "loginFailure"
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/m_page/login/loginFailure.vue